const options=window.config.env;
const DEFAULT_CONFIG = {
	//打包环境
	urlSite:options.urlSite,
	//标题
	APP_NAME: options.pageEffects.APP_NAME,

	//首页地址
	DASHBOARD_URL:options.pageEffects.dashboard,

	//版本号
	APP_VER: options.pageEffects.version,

	//内核版本号
	CORE_VER: "1.6.6",

	//接口地址
	API_URL: import.meta.env.MODE === 'development' && import.meta.env.VUE_APP_PROXY === 'true' ? "/api" :options.request.url.base||import.meta.env.VUE_APP_API_BASEURL ,

	//请求超时
	TIMEOUT: options.request.timeout,

	//TokenName
	TOKEN_NAME: options.request.token.name,

	//Token前缀，注意最后有个空格，如不需要需设置空字符串
	TOKEN_PREFIX: options.request.token.prefix,

	//追加其他头
	HEADERS: {},

	//请求是否开启缓存
	REQUEST_CACHE: options.request.cache,

	//布局 默认：default | 通栏：header | 经典：menu | 功能坞：dock
	//dock将关闭标签和面包屑栏
	LAYOUT: options.pageEffects.layout,

	//菜单是否折叠
	MENU_IS_COLLAPSE: options.pageEffects.menu_is_collapse,

	//菜单是否启用手风琴效果
	MENU_UNIQUE_OPENED: options.pageEffects.menu_unique_opened,

	//是否开启多标签
	LAYOUT_TAGS: options.pageEffects.layout_tags,

	//语言
	LANG: options.pageEffects.lang,

	//主题颜色
	COLOR: '',

	//是否加密localStorage, 为空不加密，可填写AES(模式ECB,移位Pkcs7)加密
	LS_ENCRYPTION: '',

	//localStorageAES加密秘钥，位数建议填写8的倍数
	LS_ENCRYPTION_key: options.request.ls_encryption_key,

	//控制台首页默认布局
	DEFAULT_GRID: {
		//默认分栏数量和宽度 例如 [24] [18,6] [8,8,8] [6,12,6]
		layout: [12, 6, 6],
		//小组件分布，com取值:views/home/components 文件名
		copmsList: [
			[],
			[],
			[]
		]
	},
	
	//备案标注文字
	COPYRIGHT:options.company.copyright
}
//合并业务配置
import MY_CONFIG from "./myConfig"
Object.assign(DEFAULT_CONFIG, MY_CONFIG)
// const .
// console.log(DEFAULT_CONFIG,import.meta.env)
// 如果生产模式，就合并动态的APP_CONFIG
// public/config.js
if(import.meta.env.MODE === 'production'){
	// Object.assign(DEFAULT_CONFIG, APP_CONFIG)
	Object.assign(DEFAULT_CONFIG, MY_CONFIG)
}

export default DEFAULT_CONFIG

